(function () {
  'use strict';

  function init() {
    var sticky = document.querySelector('[data-yv-sticky-atc]');
    if (!sticky) return;

    var formId = sticky.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    var primaryAtc = form.querySelector('button[name="add"]');
    if (!primaryAtc) return;

    var stickyBtn = sticky.querySelector('[data-yv-sticky-atc-trigger]');
    var stickyLabel = sticky.querySelector('[data-yv-sticky-atc-label]');
    var stickyPrice = sticky.querySelector('[data-yv-sticky-atc-price]');
    if (!stickyBtn) return;

    var priceSourceId = sticky.getAttribute('data-price-source');
    var priceSource = priceSourceId ? document.getElementById(priceSourceId) : null;

    function show() {
      sticky.removeAttribute('hidden');
      // force reflow so the transform transition runs from translateY(100%)
      void sticky.offsetHeight;
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    }
    function hide() {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }

    // Show sticky when the primary ATC is out of viewport.
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hide();
          else show();
        });
      },
      { rootMargin: '0px', threshold: 0 }
    );
    io.observe(primaryAtc);

    // Mirror primary ATC state (label + disabled) into sticky.
    function syncState() {
      stickyBtn.disabled = primaryAtc.disabled;
      if (stickyLabel) {
        var primaryLabelEl = primaryAtc.querySelector('span:not(.yv-btn__spinner)');
        var label = primaryLabelEl ? primaryLabelEl.textContent : primaryAtc.textContent;
        var trimmed = (label || '').replace(/\s+/g, ' ').trim();
        if (trimmed) stickyLabel.textContent = trimmed;
      }
    }
    syncState();
    var stateObserver = new MutationObserver(syncState);
    stateObserver.observe(primaryAtc, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    // Mirror price text from the PDP price block.
    function syncPrice() {
      if (!priceSource || !stickyPrice) return;
      var saleSpan = priceSource.querySelector('.yv-product__price-sale');
      var anySpan = priceSource.querySelector('span');
      var src = saleSpan || anySpan || priceSource;
      var text = (src.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) stickyPrice.textContent = text;
    }
    syncPrice();
    if (priceSource) {
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Sticky click → trigger primary ATC, reusing all of product-form.js logic.
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (stickyBtn.disabled || primaryAtc.disabled) return;
      stickyBtn.setAttribute('aria-busy', 'true');
      try {
        primaryAtc.click();
      } catch (err) {
        // ignore
      }
      setTimeout(function () {
        stickyBtn.removeAttribute('aria-busy');
      }, 1600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
